import logger from "../../../utils/logger";
import { loadRemedies, loadRemediesSuccess } from "../reducer/remedies";
import * as uiActions from "../reducer/ui";

const loadRemediesFlow = ({ getRemedyList }) => ({ dispatch, getState }) => (
  next
) => async (action) => {
  next(action);
  if (action.type === loadRemedies.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await getRemedyList();
      dispatch(loadRemediesSuccess(response.data));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const remediesFlow = [loadRemediesFlow];

export default remediesFlow;
